/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'notes': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.033 3a.333.333 0 00-.333.333V15c0 .184.15.333.333.333h2V3h-2zm3 0v12.333H14.2c.644 0 1.167-.522 1.167-1.166v-10C15.367 3.522 14.844 3 14.2 3H8.033zm0 13.333H14.2c1.197 0 2.167-.97 2.167-2.166v-10C16.367 2.97 15.397 2 14.2 2H5.033C4.297 2 3.7 2.597 3.7 3.333V15c0 .736.597 1.333 1.333 1.333h2V17.5a.5.5 0 001 0v-1.167z" _fill="#1F222C"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M10.367 5.833a.5.5 0 01.5-.5h1.666a.5.5 0 010 1h-1.666a.5.5 0 01-.5-.5zM10.367 9.167a.5.5 0 01.5-.5h1.666a.5.5 0 010 1h-1.666a.5.5 0 01-.5-.5z" _fill="#1F222C"/>'
  }
})
